import React from "react";
import styled from "styled-components";
import GroupingRowCount from "./GroupingRowsCount";
import PrimaryRanking from "./PrimaryRanking";
import {
    primaryRankingBackgroundColour,
    subHeaderBackgroundColour
} from "../../../../style/styleConsts";
import GroupingExportButton from "../../GroupingExportButton";


const HeaderContainer = styled.div`
    background: ${props => props.isPrimary ? primaryRankingBackgroundColour : subHeaderBackgroundColour};
    height: 40px;   
    flex-grow: 0; 
    flex-shrink: 0; 
    display: flex;
    align-items: center;
    padding: 0 14px 0;
`;

const Title = styled.div`
    font-weight: bold;
`;

const WidgetHeader = ({isPrimary, title, count, onExportClick, exportUrl}) => {
    return (
        <HeaderContainer isPrimary={isPrimary}>
        <Title>{title}</Title>
        <GroupingRowCount count={count}/>
        {!isPrimary ? null : <PrimaryRanking/>}
        <GroupingExportButton
            exportUrl={exportUrl}
            onExportClick={onExportClick}
            onExportDisabledClick={null}
            disableExportButton={false}
            addBoxShadow={false}
            buttonRightMargin={"3px"}
            imagePadding={"2px"}
            imageWidth={"19px"}
            imageHeight={"19px"}
        />
        </HeaderContainer>
    );
};

export default WidgetHeader;